'use strict';

common.View.create('website::layouts.main.Slider', {

	onDOMLoad()
	{
		this.initSlider();
	},

	initSlider()
	{
        this.element.find('.owl-carousel')
            .owlCarousel({
                center: true,
                items: 1,
                loop: true,
                autoplay: true,
                autoplayTimeout: 7500,
                autoplayHoverPause: true,
                autoplaySpeed: 1000,
                margin:20,
            });
	},

});
